import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesLeadsView } from "src/components/views/erp/sales/crm/salesLeads/SalesLeadsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesLeads")({
	staticData: { title: i18n.t("sales_leads"), legacyViewKey: "salesLeadsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesLeadsView />;
}
